import React, { useState, useEffect } from 'react';

const PwaInstallBanner = () => {
  const [show, setShow] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Se già installata come PWA o già chiuso in precedenza, non mostrare mai
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    if (navigator.standalone === true) return; // iOS
    if (localStorage.getItem('pwa-dismissed')) return;

    const handler = (e) => { e.preventDefault(); setDeferredPrompt(e); };
    window.addEventListener('beforeinstallprompt', handler);

    const timer = setTimeout(() => {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        setShow(true);
      }
    }, 5000);

    return () => { window.removeEventListener('beforeinstallprompt', handler); clearTimeout(timer); };
  }, []);

  const install = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
    }
    dismiss();
  };

  const dismiss = () => {
    setDismissed(true);
    setShow(false);
    sessionStorage.setItem('pwa-dismissed', '1');
  };

  if (!show || dismissed) return null;

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <div data-testid="pwa-install-banner"
      className="fixed inset-0 z-[99999] flex items-end justify-center bg-black/70 backdrop-blur-sm animate-fade-in-up"
      onClick={dismiss}>
      <div className="w-full max-w-md mx-4 mb-6 bg-[#0A0A0A] border border-[#00FF41]/30 rounded-2xl overflow-hidden shadow-2xl"
        style={{ boxShadow: '0 0 40px rgba(0,255,65,0.15)' }}
        onClick={e => e.stopPropagation()}>
        
        <div className="relative h-48 overflow-hidden">
          <img src="/pwa_homescreen.png" alt="AI_COVO accanto a WhatsApp" className="w-full h-full object-cover object-bottom" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
        </div>

        <div className="px-5 pb-5 -mt-4 relative">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-12 h-12 rounded-xl bg-black border border-[#00FF41]/40 flex items-center justify-center flex-shrink-0">
              <span className="font-mono font-black text-[#00FF41] text-xl" style={{ textShadow: '0 0 10px rgba(0,255,65,0.4)', letterSpacing: '3px' }}>&lt; /</span>
            </div>
            <div>
              <p className="font-bold text-white text-base">Installa <span className="text-[#00FF41] font-mono">AICOVO.TECH</span></p>
              <p className="text-zinc-400 text-xs">Di fianco a WhatsApp e Instagram</p>
            </div>
          </div>
          
          <p className="text-zinc-300 text-sm mb-4">
            {isIOS 
              ? <>Tocca <span className="text-[#00FF41] font-bold">Condividi</span> e poi <span className="text-[#00FF41] font-bold">Aggiungi a Home</span>. Un tap e sei dentro!</>
              : <>Un tap e hai il tuo Hub Sociale sempre a portata di mano. Veloce, semplice, utile.</>
            }
          </p>

          <div className="flex gap-3">
            {!isIOS && (
              <button onClick={install} data-testid="pwa-install-btn"
                className="flex-1 py-3 rounded-xl bg-[#00FF41] text-black font-bold text-sm hover:bg-[#33FF66] transition-colors">
                Installa Ora
              </button>
            )}
            <button onClick={dismiss} data-testid="pwa-dismiss-btn"
              className={`${isIOS ? 'flex-1' : ''} py-3 px-5 rounded-xl border border-zinc-700 text-zinc-400 text-sm hover:text-white transition-colors`}>
              {isIOS ? 'Ho capito!' : 'Dopo'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PwaInstallBanner;
